module.exports = __webpack_public_path__ + "static/media/heights_card_465.cccfe63d.jpg";